var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-list-post" }, [
    _c("div", { staticClass: "header-list-post" }, [
      _c("div", { staticClass: "title" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.$t("dash.posts.feed.scheduled-publications"))),
        ]),
        _c("div", { staticClass: "btns" }, [
          _c(
            "div",
            { staticClass: "btn-secondary", on: { click: _vm.newPost } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$t("dash.button.add.post")) +
                  "\n                "
              ),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "description" }, [
        _c("p", [_vm._v(_vm._s(_vm.$t("dash.posts.feed.manage-description")))]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "list-group hide-scrollbar" },
      _vm._l(_vm.lists, function (list, key, index) {
        return _c(
          "div",
          { staticClass: "group" },
          [
            _c("div", { staticClass: "date" }, [
              _c("p", [_vm._v(_vm._s(_vm.datesFormat[index]))]),
            ]),
            _c(
              "draggable",
              _vm._b(
                {
                  staticClass: "events",
                  attrs: {
                    id: "first",
                    "data-source": "juju",
                    list: list,
                    draggable: ".event",
                    group: "a",
                    "dragging-class": "dragging",
                  },
                  on: { update: _vm.updateList, remove: _vm.updateList },
                },
                "draggable",
                _vm.dragOptions,
                false
              ),
              [
                _c(
                  "transition-group",
                  { attrs: { type: "transition", name: "flip-list" } },
                  _vm._l(list, function (element) {
                    return _c(
                      "div",
                      {
                        key: element.id,
                        staticClass: "event card-status-background-color",
                        class: element.status,
                        attrs: { id: element.id },
                        on: { click: () => _vm.$emit("selectEvent", element) },
                      },
                      [
                        _c("div", { staticClass: "grip" }, [
                          _c("i", {
                            staticClass:
                              "fa-solid fa-grip-dots-vertical card-status-color",
                            class: element.status,
                          }),
                        ]),
                        _c("div", { staticClass: "content-event" }, [
                          _c("div", { staticClass: "picture" }, [
                            _c("img", { attrs: { src: element.url } }),
                          ]),
                          _c("div", { staticClass: "container-text" }, [
                            _c("div", { staticClass: "text" }, [
                              _c("p", { staticClass: "hours" }, [
                                _vm._v(_vm._s(element.format_date)),
                              ]),
                              _c("p", { staticClass: "content-post" }, [
                                _vm._v(_vm._s(element.name)),
                              ]),
                            ]),
                            _c("div", { staticClass: "badges" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "badge badge-status",
                                  attrs: { status: element.status },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(`dash.post.${element.status}`)
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }